interface SalponLogoProps {
  size?: number;
  className?: string;
}

const SalponLogo: React.FC<SalponLogoProps> = ({ size = 64, className }) => {
  const height = size * (230 / 200);

  return (
    <svg
      viewBox="0 0 200 230"
      width={size}
      height={height}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Salpön logo"
    >
      {/* Long hair flowing down */}
      <path
        d="M55 90 Q45 120 48 160 Q50 190 60 210 Q65 218 75 215 Q68 190 65 160 Q63 130 68 105Z"
        fill="#5C3317"
      />
      <path
        d="M145 90 Q155 120 152 160 Q150 190 140 210 Q135 218 125 215 Q132 190 135 160 Q137 130 132 105Z"
        fill="#5C3317"
      />
      {/* Hair top */}
      <path
        d="M52 95 Q50 70 68 58 Q85 48 100 46 Q115 48 132 58 Q150 70 148 95 Q148 105 145 110 L55 110 Q52 105 52 95Z"
        fill="#5C3317"
      />
      {/* Face */}
      <ellipse cx="100" cy="132" rx="45" ry="48" fill="#FFE0BD" />
      {/* Wavy bangs */}
      <path
        d="M58 98 Q68 80 82 78 Q90 77 95 82 Q100 77 108 78 Q122 80 130 86 Q142 95 145 105 Q138 92 125 88 Q112 85 105 90 Q100 85 92 88 Q78 90 68 98 Q62 105 58 98Z"
        fill="#6B3A1F"
      />
      {/* Crown */}
      <path
        d="M68 68 L75 38 L88 55 L100 28 L112 55 L125 38 L132 68 Z"
        fill="#FFCB61"
        stroke="#E8B84D"
        strokeWidth="1"
      />
      <rect x="68" y="65" width="64" height="8" rx="3" fill="#FFCB61" stroke="#E8B84D" strokeWidth="1" />
      {/* Crown gems */}
      <circle cx="100" cy="36" r="4" fill="#EA5B6F" />
      <circle cx="75" cy="46" r="3" fill="#77BEF0" />
      <circle cx="125" cy="46" r="3" fill="#77BEF0" />
      <circle cx="84" cy="70" r="2.5" fill="#FF894F" />
      <circle cx="100" cy="70" r="2.5" fill="#FF894F" />
      <circle cx="116" cy="70" r="2.5" fill="#FF894F" />
      {/* Eyes - happy closed */}
      <path d="M78 125 Q85 116 92 125" stroke="#2C1810" strokeWidth="3" fill="none" strokeLinecap="round" />
      <path d="M108 125 Q115 116 122 125" stroke="#2C1810" strokeWidth="3" fill="none" strokeLinecap="round" />
      {/* Lashes */}
      <line x1="78" y1="125" x2="76" y2="121" stroke="#2C1810" strokeWidth="2" strokeLinecap="round" />
      <line x1="92" y1="125" x2="94" y2="121" stroke="#2C1810" strokeWidth="2" strokeLinecap="round" />
      <line x1="108" y1="125" x2="106" y2="121" stroke="#2C1810" strokeWidth="2" strokeLinecap="round" />
      <line x1="122" y1="125" x2="124" y2="121" stroke="#2C1810" strokeWidth="2" strokeLinecap="round" />
      {/* Small nose */}
      <ellipse cx="100" cy="137" rx="3" ry="2" fill="#F0C9A0" />
      {/* Cheeks */}
      <ellipse cx="74" cy="145" rx="9" ry="6" fill="#FF894F" opacity="0.3" />
      <ellipse cx="126" cy="145" rx="9" ry="6" fill="#FF894F" opacity="0.3" />
      {/* Cute smile with tongue */}
      <path d="M88 153 Q100 166 112 153" stroke="#2C1810" strokeWidth="2.5" fill="none" strokeLinecap="round" />
      <ellipse cx="100" cy="160" rx="6" ry="4" fill="#EA5B6F" opacity="0.6" />
    </svg>
  );
};

export default SalponLogo;
